import React, { useState, useEffect } from 'react';
import { api } from '../../api';
import toast from 'react-hot-toast';


const CreateCaseModal = ({ user, onClose, onCaseCreated }) => {
    const [properties, setProperties] = useState([]);
    const [devices, setDevices] = useState([]);
    const [selectedProperty, setSelectedProperty] = useState('');
    const [formData, setFormData] = useState({
        device_id: '',
        priority: 'MEDIUM',
        subject: '',
        description: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const props = await api.getProperties();
                setProperties(props);
            } catch (error) {
                toast.error('Failed to load properties.');
            }
        };
        fetchInitialData();
    }, []);

    useEffect(() => {
        if (selectedProperty) {
            const fetchDevices = async () => {
                try {
                    const allDevices = await api.getDevices();
                    const filteredDevices = allDevices.filter(d => d.property_id === parseInt(selectedProperty));
                    setDevices(filteredDevices);
                } catch (error) {
                    toast.error('Failed to load devices for the selected property.');
                }
            };
            fetchDevices();
        } else {
            setDevices([]);
        }
    }, [selectedProperty]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const finalData = {
            ...formData,
            property_id: selectedProperty
        };

        if (!finalData.property_id || !finalData.device_id || !finalData.subject || !finalData.description) {
            toast.error('All fields are required.');
            setIsSubmitting(false);
            return;
        }

        try {
            await api.createCase(finalData);
            toast.success('Support case created successfully!');
            onCaseCreated();
        } catch (error) {
            toast.error(error.message || 'Failed to create case.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Create a New Support Case</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-row">
                        <div className="form-group">
                            <label className="form-label">Property</label>
                            <select className="form-input" value={selectedProperty} onChange={e => setSelectedProperty(e.target.value)} required>
                                <option value="">Select a Property</option>
                                {properties.map(prop => <option key={prop.id} value={prop.id}>{prop.name}</option>)}
                            </select>
                        </div>
                        <div className="form-group">
                            <label className="form-label">Device</label>
                            <select name="device_id" className="form-input" value={formData.device_id} onChange={handleInputChange} required disabled={!selectedProperty}>
                                <option value="">Select a Device</option>
                                {devices.map(dev => <option key={dev.id} value={dev.id}>{dev.name || dev.serial_number}</option>)}
                            </select>
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="form-label">Priority</label>
                        <select name="priority" className="form-input" value={formData.priority} onChange={handleInputChange} required>
                            <option value="LOW">Low</option>
                            <option value="MEDIUM">Medium</option>
                            <option value="HIGH">High</option>
                            <option value="URGENT">Urgent</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label className="form-label">Subject</label>
                        <input type="text" name="subject" className="form-input" value={formData.subject} onChange={handleInputChange} required />
                    </div>
                    <div className="form-group">
                        <label className="form-label">Description</label>
                        <textarea name="description" className="form-input" rows="5" value={formData.description} onChange={handleInputChange} required></textarea>
                    </div>
                    <div className="modal-actions">
                        <button type="button" className="button button-secondary" onClick={onClose} disabled={isSubmitting}>Cancel</button>
                        <button type="submit" className="button action-button" disabled={isSubmitting}>
                            {isSubmitting ? 'Submitting...' : 'Submit Case'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateCaseModal;
